import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchTenant, DEFAULT_TENANT_SLUG } from '@/lib/tenant';
import { useLiveBookings } from '@/lib/useLiveBookings';
import { TabBar } from './TabBar';

// Корневая архитектура: один сайт на деплой, салон фиксирован slug-ом сборки.
// Владелец живёт на /admin и /admin/dashboard, клиент — на /, /book, /profile.
// Нижние табы показываем только клиенту, в админке их нет.
export function TenantLayout() {
  const { pathname } = useLocation();
  const slug = DEFAULT_TENANT_SLUG;

  // Живое обновление записей на всём сайте: занятый другим клиентом слот
  // исчезает из списка свободного времени без перезагрузки страницы.
  useLiveBookings();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['tenant', slug],
    queryFn: () => fetchTenant(slug),
    enabled: Boolean(slug)
  });

  useEffect(() => {
    if (data?.theme?.accent) {
      document.documentElement.style.setProperty('--mnc-accent', data.theme.accent);
      document.documentElement.style.setProperty(
        '--mnc-accent-soft',
        data.theme.accent + '29'
      );
    }
    if (data?.name) {
      document.title = `${data.name} — запись онлайн`;
    }
  }, [data]);

  if (isLoading) return <div className="mnc-page">Загружаем салон…</div>;
  if (isError || !data) {
    return <div className="mnc-page">Салон не найден.</div>;
  }

  const isAdminArea = pathname.startsWith('/admin');

  return (
    <>
      <Outlet context={{ tenant: data }} />
      {!isAdminArea && <TabBar />}
    </>
  );
}
